/**
 * Entry point for webpack.config.js, in order to generate the scripts folder bundle.
 */
import 'regenerator-runtime/runtime'
import $ from 'jquery'
import * as Sentry from '@sentry/browser'
import { Datacenter, datadogRum } from '@datadog/browser-rum'
import { ExtraErrorData } from '@sentry/integrations'

import componentLoader from 'scripts/component-loader'

const shouldInitSentry = function () {
  return window.env && window.env.sentry.enabled === true
}

if (shouldInitSentry()) {
  Sentry.init({
    dsn: window.env.sentry.key,
    release: process.env.SENTRY_RELEASE,
    environment: window.env.sentry.environment,
    integrations: [new ExtraErrorData()]
  })
}

const shouldInitDataDog = function () {
  return window.env && window.env.datadog.enabled === true
}

if (shouldInitDataDog()) {
  datadogRum.init({
    env: window.env.datadog.env,
    service: window.env.datadog.service,
    version: window.env.datadog.version,
    applicationId: window.env.datadog.applicationId,
    datacenter: Datacenter.US,
    clientToken: window.env.datadog.clientToken,
    sampleRate: window.env.datadog.sampleRate,
    trackInteractions: window.env.datadog.trackInteractions,
    allowedTracingOrigins: window.env.datadog.tracingOrigins.split(','),
    silentMultipleInit: true
  })
}

$.ajaxSetup({
  xhrFields: {
    withCredentials: true
  }
})

/**
 * Uses the @method componentLoader on a jQuery selection of [data-component].
 * In order to use a dynamic [data-component] (Outside of the DOMReady scope), please refer to the component-loader.
 * @param  {element}
 */
componentLoader($('[data-component]'))
